var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<md-dialog aria-label=\"Terms & Conditions\" flex=\"grow\" ng-cloak>\n<form>\n<md-toolbar class=\"md-hue-2\">\n<div class=\"md-toolbar-tools\">\n<h2>Terms & Conditions</h2>\n<div flex></div>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<i class=\"material-icons\" aria-label=\"Close message\" style=\"font-size:28px;\">close</i>\n</md-button>\n</div>\n</md-toolbar>\n<md-dialog-content>\n<div ng-bind-html=\"terms\"></div>\n</md-dialog-content>\n<md-dialog-actions layout=\"row\" style=\"padding:15px 20px 15px 0;\">\n<div flex></div>\n<md-button class=\"md-primary\" ng-click=\"cancel()\" style=\"padding:0 30px;\">\nReturn\n</md-button>\n</md-dialog-actions>\n</form>\n</md-dialog>";
var id1="components/public/account-request-terms.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/components/public/account-request-terms.html
// module id = 679
// module chunks = 0